import React from 'react';

import CandidateResponseLayout from './layout';
import SimpleMessage from './simple_message';

type Props = {
  title: string;
  body: string;
};

const Notice = (props: Props) => {
  return (
    <CandidateResponseLayout>
      <SimpleMessage {...props} />
    </CandidateResponseLayout>
  );
};

export default Notice;
